<template>
  <div class="menuSetting">
    <el-container>
      <el-aside>
        <div class="menuTitlePanel">
          菜单树
          <img
            v-if="true"
            @click="deleteMenuBtn"
            src="@/assets/images/common/icon_delete.png"
          />
          <img
            v-if="true"
            @click="modifyMenu"
            src="@/assets/images/common/icon_modify.png"
          />
          <img
            v-if="true"
            @click="addMenu"
            src="@/assets/images/common/icon_add.png"
          />
        </div>
        <el-tree
          :data="menuList"
          :props="defaultProps"
          :default-expand-all="true"
          @node-click="handleNodeClick"
          highlight-current
        >
          <span class="treeNodeTxt" slot-scope="{node,data}">
            <img
              class="treeNodeIcon"
              src="@/assets/images/common/icon_tree_node.png"
              v-if="data.subMenuList.length>0"
            />
            <span>{{ data.name }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main>
        <div class="menuDetailPanel">
          <el-row>
            <el-form :inline="true" :model="meunDetail" class="form">
              <el-col :span="8">
                <el-form-item label="名称">
                  <el-input v-model="meunDetail.name" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="组件">
                  <el-input v-model="meunDetail.component" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="path">
                  <el-input v-model="meunDetail.path" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="排序">
                  <el-input v-model="meunDetail.sort" disabled></el-input>
                </el-form-item>
              </el-col>
               <el-col :span="8">
                <el-form-item label="级数">
                  <el-input v-model="meunDetail.level" disabled></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="备注">
                  <el-input v-model="meunDetail.remark" disabled></el-input>
                </el-form-item>
              </el-col>-->
            </el-form>
          </el-row>
        </div>
        <el-row>
          <div class="operatePanel">
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="addBtnClick()"
            >新增</el-button>
            <!-- <el-button
              type="primary"
              icon="el-icon-edit"
              @click="updateBtnClick()"
              v-if="btnAuthorize.modifyBtn.btnEnable"
            >修改</el-button>-->
            <el-button
              type="primary"
              icon="el-icon-delete"
              @click="deleteBtnClick()"
            >删除</el-button>
          </div>
        </el-row>
        <div class="btnTitlePanel">菜单按钮</div>
        <div>
          <el-tree :data="meunBtnList" :props="defaultProps1" @node-click="menuBtnClick"></el-tree>
        </div>
      </el-main>
    </el-container>
    <!-- 新增/修改菜单弹窗 -->
    <el-dialog
      class="dialog816"
      :title="isAddMenu?'新增菜单':'修改菜单'"
      :visible.sync="isAddDialogShow"
      :before-close="closeMenuDialog"
      :close-on-click-modal="false"
    >
      <el-form :model="menuForm" ref="menuForm" label-width="60px" :rules="menuRules">
        <el-row>
          <el-col :span="11">
            <el-form-item label="名称" prop="name">
              <el-input v-model="menuForm.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组件">
              <el-input v-model="menuForm.component" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="类型" prop="type">
              <el-select v-model="menuForm.type">
                <el-option
                  v-for="type in typeList"
                  :key="type.type"
                  :label="type.typeName"
                  :value="type.type"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row>
          <el-col :span="11">
            <el-form-item label="URL">
              <el-input v-model="menuForm.path"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input v-model="menuForm.sort"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
         <el-row>
          <el-col :span="11">
            <el-form-item label="级数" prop="level">
              <el-input v-model="menuForm.level"></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="12">
             <el-form-item label="类别" prop="type">
               <el-select v-model="menuForm.type">
                 <el-option label="普通菜单" value="common"></el-option>
                 <el-option label="小程序菜单" value="wechat"></el-option>
               </el-select>
             </el-form-item>
           </el-col>
        </el-row>
        <!-- <el-row>
          <el-col :span="23">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="menuForm.remark" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeMenuDialog">关闭</el-button>
        <el-button type="primary" @click="menuSave()">保存</el-button>
      </div>
    </el-dialog>
    <!-- 新增/修改按钮弹窗 -->
    <el-dialog
      class="dialog816"
      :title="isAddMenuBtn?'新增按钮':'修改按钮'"
      :visible.sync="isAddBtnDialogShow"
      :before-close="closeBtnDialog"
      :close-on-click-modal="false"
    >
      <el-form :model="btnForm" ref="btnForm" label-width="80px" :rules="btnRules">
        <el-row>
          <el-col :span="11">
            <el-form-item label="按钮名称" prop="permissionDictKey">
              <!-- <el-input v-model="btnForm.permissionDictValue" autocomplete="off"></el-input> -->
               <el-select v-model="btnForm.permissionDictKey">
                <el-option
                  :label="btn.value"
                  :value="btn.label"
                  v-for="btn in buttonList"
                  :key="btn.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col span="12">
            <el-form-item label="执行方法" prop="buttonUrl">
              <el-input v-model="btnForm.buttonUrl" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>-->
        </el-row>
        <!-- <el-row>
          <el-col span="11">
            <el-form-item label="图标样式" prop="buttonStyle">
              <el-input v-model="btnForm.buttonStyle"></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="排序" prop="sortNo">
              <el-input v-model="btnForm.sort"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="23">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="btnForm.remark" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>-->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeBtnDialog">关闭</el-button>
        <el-button type="primary" @click="btnSave()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getDeptAssginMenuTreeService, //获取全部菜单项
  getMenuDetailsService,
  addNewMenuService,
  modifyMenuService,
  deleteMenuService,
  getDeptGrantMenuBtnTreeService,
  getMenuBtnDetailService,
  addMenuBtnService,
  updateMenuBtnService,
  deleteMenuBtnService,
  getButtonNamesService   //获取全部按钮名称
} from "../../services/sysSettingService";
export default {
  name: "menuSetting",
  data() {
    return {
      total: 0, //门禁总数
      menuSelected: null, //选中的菜单节点
      btnSelected: null, //选中的按钮ID
      menuList: [], //全部菜单列表
      meunBtnList: [], //菜单按钮列表
      buttonList:[],   //按钮下拉列表
      isAddDialogShow: false, //新增菜单弹窗显示开关
      isAddBtnDialogShow: false, //新增按钮弹窗显示开关
      isAddMenu: true, //是否新增or修改判断
      isAddMenuBtn: true, //是否新增or修改按钮判断
      defaultProps: {
        label: "name",
        children: "subMenuList",
        value: "id"
      },
      defaultProps1: {
        label: "permissionDictValue",
        children: "subMenuList",
        value: "id"
      },
      meunDetail: {},
      /* 下拉框筛选数据 */
      typeList: [
        { typeName: "目录", type: "2" },
        { typeName: "菜单", type: "1" }
      ],
      /* 菜单新增/修改Form */
      menuForm: {
        name: "",
        path: "",
        sort: "",
        level:"",
        component: "",
        type: ""
      },
      /* 按钮新增/修改Form */
      btnForm: {
        permissionDictKey: "" //名称
      },
      page: 1,
      rows: 10,
      menuRules: {
        name: [
          { required: true, message: "该输入项为必输项", trigger: "blur" }

        ],
        sort: [
          { required: true, message: "该输入项为必输项", trigger: "blur" }
        ],
        level: [
          { required: true, message: "该输入项为必输项", trigger: "blur" }
        ],
        type: [
          { required: true, message: "该输入项为必输项", trigger: "blur" }
        ]
      },
      btnRules: {
        permissionDictKey: [
          { required: true, message: "该输入项为必输项", trigger: "blur" }
        ]
      }
      //按钮权限
      // btnAuthorize: {
      //   addMenu: { key: "createMenu", btnEnable: true },
      //   modifyMenu: { key: "updateMenu", btnEnable: true },
      //   delMenu: { key: "deleteMenu", btnEnable: true },
      //   addBtn: { key: "create", btnEnable: false },
      //   // modifyBtn: { btnCode: "2020042309462062214", btnEnable: false },
      //   delBtn: { key: "delete", btnEnable: false }
      // }
    };
  },
  props: {
    menuCode: {
      type: String
    }
  },
  methods: {
    //激活时调用
    onActive(menuCode) {
      // this.$getRoleBtns(menuCode, this.btnAuthorize);

      if (this.$refs.menuForm) {
        this.$refs.menuForm.resetFields();
      }
      if (this.$refs.btnForm) {
        this.$refs.btnForm.resetFields();
      }
      this.meunDetail = {};
      this.menuSelected = null;
      this.btnSelected = null;
      this.meunBtnList = [];
      this.getAllMenu();
    },
    /* 获取全部菜单列表 */
    getAllMenu() {
      let params = {
        // pageIndex: 1,
        // pageSize: 100
        // currentUserId : sessionStorage.getItem('currentUserId')
      };
      getDeptAssginMenuTreeService(params).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.menuList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 获取菜单详情 */
    getMenuDetails(menuCode) {
      let requestParam = {
        menuId: menuCode
      };
      getMenuDetailsService(requestParam).then(
        res => {
          if (res.code == 10000000) {
            // res.data.sortNo = res.data.sort + "";
            this.meunDetail.id = res.data.id;
            this.meunDetail.name = res.data.name;
            this.meunDetail.pid = res.data.pid;
            // this.meunDetail.typeName = res.data.type == "2" ? "目录" : "菜单";
            this.meunDetail.path = res.data.path;
            this.meunDetail.sort = res.data.sort;
             this.meunDetail.level = res.data.level;
             this.meunDetail.type = res.data.type;
            this.meunDetail.component = res.data.component;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 获取菜单包含按钮列表 */
    getMenuBtnList(menuCode) {
      let requestParam = {
        menuId: menuCode
        // userCode: sessionStorage.getItem("userCode")
      };
      getDeptGrantMenuBtnTreeService(requestParam).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.meunBtnList = res.data;
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 新增菜单请求 */
    addMenuReq() {
      if (this.menuSelected != null) {
        this.menuForm.pid = this.menuSelected.id;
        this.menuForm.level = this.menuSelected.level + 1;
      }

      // param.currentUserId =  parseInt(sessionStorage.getItem("currentUserId"));
      addNewMenuService(this.menuForm).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.isAddDialogShow = false;
            this.$alert("新增成功", "提示");
            this.getAllMenu();
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 修改菜单请求 */
    modifyMenuReq() {
      // this.menuForm.currentUserId = sessionStorage.getItem("currentUserId");
      this.menuForm.id = this.meunDetail.id;
      this.menuForm.pid = this.meunDetail.pid;
      modifyMenuService(this.menuForm).then(
        res => {
          if (res.code == 10000000) {
            this.isAddDialogShow = false;
            this.$alert("修改成功", "提示");
            this.getAllMenu();
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 删除菜单请求 */
    deleteMenu(menuCode) {
      let requestParam = {
        menuId: menuCode
        // currentUserId: sessionStorage.getItem("currentUserId")
      };
      deleteMenuService(requestParam).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("删除成功", "提示");
            this.getAllMenu();
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },

    /* 获取菜单按钮详情请求 */
    getMenuBtnDetail(btnCode) {
      let requestParam = {
        buttonCode: this.btnSelected.id
      };
      getMenuBtnDetailService(requestParam).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.btnForm = res.data;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 新增按钮请求 */
    addMenuBtn() {
      this.btnForm.menuId = this.menuSelected.id;
      // this.btnForm.permissionDictKey = "create";
      // this.btnForm.createUserId = sessionStorage.getItem("currentUserId");
      if (this.btnSelected != null) {
        this.btnForm.id = this.btnSelected.id;
      }
      let param = [];
      param.push(this.btnForm);
      addMenuBtnService(param).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.isAddBtnDialogShow = false;
            this.$alert("新增成功", "提示");
            this.getMenuBtnList(this.menuSelected.id);
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 修改按钮请求 */
    updateMenuBtn() {
      this.btnForm.userCode = sessionStorage.getItem("userCode");
      updateMenuBtnService(this.btnForm).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.isAddBtnDialogShow = false;
            this.$alert("修改成功", "提示");
            this.getMenuBtnList(this.menuSelected.id);
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 删除菜单按钮请求 */
    deleteMenuBtnReq(buttonCode) {
      let requestParam = {
        permissionIDSet: buttonCode
        // userCode: sessionStorage.getItem("userCode")
      };
      deleteMenuBtnService(requestParam).then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            this.$alert("删除成功", "提示");
            this.getMenuBtnList(this.menuSelected.id);
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 菜单点击回调事件 */
    handleNodeClick(menu) {
      console.log(menu);
      this.menuSelected = menu;
      this.btnSelected = null;
      this.getMenuDetails(menu.id);
      if (null != menu.subMenuList && menu.subMenuList <= 0) {
        this.getMenuBtnList(menu.id);
      }else{
        this.meunBtnList =[];
      }

      // if (menu.state == "open") {
      //   this.getMenuDetails(menu.id);
      //   this.getMenuBtnList(menu.id);
      // }
    },
    /* 按钮点击回调事件 */
    menuBtnClick(btn) {
      this.btnSelected = btn;
    },
    /* 菜单新增按钮回调 */
    addMenu() {
      this.isAddDialogShow = true;
      this.isAddMenu = true;
    },
    /* 菜单修改按钮回调 */
    modifyMenu() {
      if (this.menuSelected == null) {
        this.$message.error("请选择一条数据进行修改");
        return;
      }
      this.isAddDialogShow = true;
      this.$nextTick(() => {
        this.menuForm.id = this.meunDetail.id;
        this.menuForm.name = this.meunDetail.name;
        this.menuForm.pid = this.meunDetail.pid;
        this.menuForm.component = this.meunDetail.component;
        this.menuForm.path = this.meunDetail.path;
        this.menuForm.sort = this.meunDetail.sort;
        this.menuForm.level = this.meunDetail.level;
        this.menuForm.type = this.meunDetail.type;
        // this.menuForm.remark = this.meunDetail.remark;
      });
      this.isAddMenu = false;
      this.getMenuDetails(this.menuSelected.id);
    },
    /* 菜单删除按钮回调 */
    deleteMenuBtn() {
      this.$confirm("确认删除菜单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.deleteMenu(this.menuSelected.id);
      });
    },
    closeMenuDialog() {
      this.$refs.menuForm.resetFields();
      this.isAddDialogShow = false;
    },
    closeBtnDialog() {
      this.$refs.btnForm.resetFields();
      this.isAddBtnDialogShow = false;
    },
    /* 菜单修改-保存按钮回调 */
    menuSave() {
      this.$refs.menuForm.validate(res => {
        if (res) {
          if (this.isAddMenu) {
            this.addMenuReq();
          } else {
            this.modifyMenuReq();
          }
        }
      });
    },
    /* 新增菜单按钮回调 */
    addBtnClick() {
      this.isAddBtnDialogShow = true;
      this.isAddMenuBtn = true;
      /* 清空form数据 */
      this.btnForm.permissionDictKey = "";
      this.getButtonNames();
    },
    /* 修改菜单按钮回调 */
    updateBtnClick() {
      if (this.btnSelected == null) {
        this.$alert("请选择要修改的按钮", "提示");
        return;
      }
      this.isAddBtnDialogShow = true;
      this.isAddMenuBtn = false;
      this.getMenuBtnDetail();
    },
    /* 删除菜单按钮回调 */
    deleteBtnClick() {
      if (this.btnSelected == null) {
        this.$alert("请选择要删除的按钮", "提示");
        return;
      }
      this.$confirm("确认删除按钮?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.deleteMenuBtnReq(this.btnSelected.id);
      });
    },
    /* 按钮修改-保存按钮回调 */
    btnSave() {
      this.$refs.btnForm.validate(res => {
        if (res) {
          if (this.isAddMenuBtn) {
            this.addMenuBtn();
          } else {
            this.updateMenuBtn();
          }
        }
      });
    },
     //获取菜单下拉列表数据
    getButtonNames() {
       getButtonNamesService().then(
        res => {
          console.log(res);
          if (res.code == 10000000) {
            console.log('下拉菜单的可选值', res.data);
            this.buttonList = res.data;

          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
  }
};
</script>

<style scoped lang="scss">
.menuSetting {
  height: 100%;
  background-color: #e9f4fa;
  .el-container {
    height: 100%;
    /* 左边菜单栏 */
    .el-aside {
      padding: 24px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      .menuTitlePanel {
        font-size: 18px;
        font-weight: 500;
        text-align: left;
        margin-bottom: 16px;
        img {
          vertical-align: middle;
          float: right;
          margin: 5px 8px 0 0;
        }
      }
      .el-tree {
        background-color: #f0f5f7;
        height: 95%;
        overflow: auto;
      }
    }
    /* 右侧内容 */
    .el-main {
      margin-left: 16px;
      background-color: #fff;
      .menuDetailPanel {
        text-align: left;
        padding: 16px 0 0 0;
        border-bottom: 1px solid #e6e6e6;
      }
      .operatePanel {
        text-align: right;
        margin: 16px 0;
        padding: 0 20px;
      }
      .btnTitlePanel {
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        background-color: #edf8fa;
        padding: 16px;
        margin-bottom: 16px;
      }
    }
  }
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
